// @ts-nocheck

import React, { useEffect, useState } from 'react';
import styled, { css, keyframes } from 'styled-components';

import { Target } from '../../../../client';
import colors from '../../../../styled-components/palette';
import { NewTag } from '../../../../styled-components/shared';

const LIST_ITEM_HEIGHT = 3.3; // em

const Wrapper = styled.div`
  height: ${LIST_ITEM_HEIGHT}em;
  padding: 0 0.5em;
  font-size: 1em;
  position: relative;
  display: flex;
  align-items: center;
  background-color: ${colors.bluegrey900};
  transition: background-color 0.2s ease-in-out;
  cursor: pointer;
  color: #fff;
  overflow: hidden;

  &:active {
    background-color: ${colors.bluegrey850};
  }

  &:hover {
    background-color: ${colors.bluegrey850};
  }

  &:not(:first-child) {
    &::before {
      content: '';
      background-color: ${colors.bluegrey800};
      position: absolute;
      left: 3em;
      right: 0.5em;
      height: 1px;
      top: 0;
    }
  }

  ${!Target.__MOBILE__
    ? css`
        &:hover {
          background-color: ${colors.bluegrey850};
        }
      `
    : null}
`;

const Icon = styled.div`
  margin-left: 0.2em;
  margin-right: 0.5em;
  display: flex;
  align-items: center;
  width: 1.7em;
  height: 1.7em;
`;

const RightIcon = styled.div`
  margin-right: 0.8em;
  margin-left: auto;
`;

const Label = styled.span`
  padding-right: 0.3em;
  height: 100%;
  display: flex;
  align-items: center;
  letter-spacing: normal;
  font-weight: normal;
  position: relative;

  ${({ $translate }) =>
    $translate !== null
      ? $translate
        ? css`
            animation: ${appearTranslate} 0.3s ease-in-out forwards;
          `
        : css`
            animation: ${disappearTranslate} 0.3s ease-in-out backwards;
          `
      : null}
`;

const appearTranslate = keyframes`
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-70%);
  }
`;

const disappearTranslate = keyframes`
  0% {
    transform: translateY(-70%);
  }
  100% {
    transform: translateY(0);
  }
`;

const LabelOnClick = styled.span`
  ${({ $isSuccess }) =>
    $isSuccess
      ? css`
          color: ${colors.black};
          background-color: ${colors.greenwinamax400};
        `
      : css`
          color: ${colors.redwinamax350};
          background-color: ${colors.redwinamax850};
        `};
  position: absolute;
  left: 0;
  top: 100%;
  padding: 0.1em 0.2em;
  font-size: 0.85em;
  border-radius: 0.2em;
`;

const StyledNewTag = styled(NewTag)`
  color: ${colors.yellowwinamax350};
  font-weight: normal;

  &:last-child {
    margin-left: auto;
  }
`;

type BetslipOptionsItemClickProps = {
  className?: string;
  showNewTag?: boolean;
  onClick: () => void;
  label: string;
  labelOnClick?: string;
  showLabelOnClick?: boolean;
  labelOnClickIsSuccess?: boolean;
  icon: unknown;
  rightIcon?: unknown;
};

const BetslipOptionsItemClick = ({
  className = '',
  showNewTag = false,
  onClick,
  label,
  labelOnClick,
  showLabelOnClick = false,
  labelOnClickIsSuccess = false,
  icon,
  rightIcon,
}: BetslipOptionsItemClickProps) => {
  const [allowAnimation, setAllowAnimation] = useState<boolean | null>(null);

  useEffect(() => {
    if (showLabelOnClick && !!labelOnClick && allowAnimation === null) {
      setAllowAnimation(true);
    }
  }, [allowAnimation, labelOnClick, showLabelOnClick]);

  return (
    <Wrapper className={className} onClick={onClick}>
      <Icon>{icon}</Icon>
      <Label $translate={!allowAnimation ? null : showLabelOnClick}>
        {label}
        <LabelOnClick $isSuccess={labelOnClickIsSuccess}>{labelOnClick}</LabelOnClick>
      </Label>
      {showNewTag ? <StyledNewTag>New</StyledNewTag> : null}
      {rightIcon ? <RightIcon>{rightIcon}</RightIcon> : null}
    </Wrapper>
  );
};

export default BetslipOptionsItemClick;
